import { useEffect, useState } from 'react';
import {
  LEGENDA_INSPIRA,
  LEGENDA_PRESENCA,
  LEGENDA_SOLTA,
  RUBRICA_RESPIRA,
} from '../constantes';

// Respiro guiado: uma luz que cresce e diminui (132px) e uma legenda que troca
// a cada 4s por 3 ciclos ("Inspire…/Solte…"), terminando em "Deus está aqui
// com você.". Com redução de movimento, fica tudo parado.
function usaReducao(): boolean {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

export default function Respiro() {
  const reduz = usaReducao();
  // 0..5 = respira; 6 = terminou.
  const [etapa, setEtapa] = useState(0);

  useEffect(() => {
    if (reduz || etapa >= 6) return;
    const t = window.setTimeout(() => setEtapa((e) => e + 1), 4000);
    return () => window.clearTimeout(t);
  }, [etapa, reduz]);

  const legenda = reduz
    ? RUBRICA_RESPIRA
    : etapa >= 6
      ? LEGENDA_PRESENCA
      : etapa % 2 === 0
        ? LEGENDA_INSPIRA
        : LEGENDA_SOLTA;

  return (
    <div className="flex flex-col items-center">
      <div className="respiro" aria-hidden />
      <p
        className="mt-4 min-h-[24px] text-center text-[15px] font-medium text-[color:var(--texto-2)]"
        aria-live="polite"
      >
        {legenda}
      </p>
    </div>
  );
}